import { render, staticRenderFns } from "./UserStories.vue?vue&type=template&id=4c76f3ac&scoped=true&"
import script from "./UserStories.vue?vue&type=script&lang=js&"
export * from "./UserStories.vue?vue&type=script&lang=js&"
import style0 from "./UserStories.vue?vue&type=style&index=0&id=4c76f3ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c76f3ac",
  null
  
)

export default component.exports